import { getChaptersStorage } from "./getChaptersStorage";

export const pharosReadProgressLocalStorageKey = "pharos-read-progress";

const { markSubchapter, isSubchapterMarked } =
  getChaptersStorage(pharosReadProgressLocalStorageKey);

export const saveProgressLocally = markSubchapter;
export const isSubchapterRead = isSubchapterMarked;
